import { z } from 'zod/v4';

export const assetIdentifierOptions = [
  'Vehicle ID',
  'Email',
  'Phone ID',
  'Driver/Employee ID',
  'Device ID',
  'Inventory/Barcode ID',
] as const;

export const assetIdentifierSchema = z.enum(assetIdentifierOptions);

export type AssetIdentifier = z.infer<typeof assetIdentifierSchema>;
